/**
 * JINSA – Enhanced Mega-Menu
 * Replaces the raw link-list inside the "Todos los Productos" and
 * "Todas las Marcas" dropdowns with styled category/brand grids.
 *
 * The data (categories + brands) mirrors the navigation links that must
 * exist in the Shopify navigation editor.  The JS matches nav items by
 * their visible text and injects better HTML.
 */
(function () {
  'use strict';

  // ── Category data: loaded from Liquid-rendered JSON (real product counts) ──
  function loadCategories() {
    try {
      const el = document.getElementById('jinsa-collection-data');
      if (el) return JSON.parse(el.textContent);
    } catch (e) { /* fall through to defaults */ }
    // Fallback if snippet is missing
    return [
      { code: 'PR', name: 'Manómetros y presión', count: '—', handle: 'manometros-y-presion' },
      { code: 'SE', name: 'Sensores',             count: '—', handle: 'sensores' },
      { code: 'TI', name: 'Temporizadores',       count: '—', handle: 'temporizadores' },
      { code: 'RE', name: 'Relés y contactores',  count: '—', handle: 'reles-y-contactores' },
      { code: 'PL', name: 'Controladores / PLC',  count: '—', handle: 'controladores-plc' },
      { code: 'FU', name: 'Fuentes de poder',     count: '—', handle: 'fuentes-de-poder' },
      { code: 'CO', name: 'Conectores y bases',   count: '—', handle: 'conectores-y-bases' },
      { code: 'TE', name: 'Termómetros',          count: '—', handle: 'termometros' },
    ];
  }
  const CATEGORIES = loadCategories();

  // ── Static brand data ─────────────────────────────────────────────────────
  // Update `handle` to match your Shopify collection or vendor handles.
  const BRANDS = [
    { name: 'Autonics',          handle: 'autonics' },
    { name: 'Winters',           handle: 'winters' },
    { name: 'Pepperl+Fuchs',     handle: 'pepperl-fuchs' },
    { name: 'Siemens',           handle: 'siemens' },
    { name: 'Maxon',             handle: 'maxon' },
    { name: 'Schneider Electric', handle: 'schneider-electric' },
    { name: 'Camozzi',           handle: 'camozzi-automation' },
    { name: 'Honeywell',         handle: 'honeywell' },
    { name: 'Mantova',           handle: 'mantova' },
    { name: 'Danfoss',           handle: 'danfoss' },
    { name: 'Aeco',              handle: 'aeco' },
    { name: 'Banner',            handle: 'banner' },
  ];

  // ── Keyword matchers ──────────────────────────────────────────────────────
  const PRODUCTS_KEYWORDS = ['todos los productos', 'all products', 'productos'];
  const BRANDS_KEYWORDS   = ['todas las marcas', 'all brands', 'marcas'];

  function matches(text, keywords) {
    return keywords.some(k => text.toLowerCase().includes(k));
  }

  // ── Build categories HTML ─────────────────────────────────────────────────
  function buildCategoriesHTML() {
    const items = CATEGORIES.map(c => `
      <a class="jinsa-mega-cat-item" href="/collections/${c.handle}">
        <span class="jinsa-mega-cat-badge">${c.code}</span>
        <span class="jinsa-mega-cat-info">
          <span class="jinsa-mega-cat-name">${c.name}</span>
          <span class="jinsa-mega-cat-count">${c.count} productos</span>
        </span>
      </a>`
    ).join('');

    return `
      <div class="jinsa-mega-wrapper">
        <span class="jinsa-mega-section-title">Explorar categorías</span>
        <div class="jinsa-mega-categories">${items}</div>
        <a class="jinsa-mega-view-all" href="/collections/all">
          Ver todos los productos
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </a>
      </div>`;
  }

  // ── Build brands HTML ─────────────────────────────────────────────────────
  function buildBrandsHTML() {
    const chips = BRANDS.map(b =>
      `<a class="jinsa-mega-brand-chip" href="/collections/${b.handle}">${b.name}</a>`
    ).join('');

    return `
      <div class="jinsa-mega-wrapper">
        <span class="jinsa-mega-section-title">Marcas disponibles</span>
        <div class="jinsa-mega-brands">${chips}</div>
        <a class="jinsa-mega-view-all" href="/collections/all">
          Ver todas las marcas
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </a>
      </div>`;
  }

  // ── Inject into a dropdown-inner ─────────────────────────────────────────
  function enhance(dropdownInner, html) {
    if (dropdownInner.dataset.jinsaEnhanced) return;
    dropdownInner.dataset.jinsaEnhanced = '1';
    // Force solid background so content doesn't bleed through
    dropdownInner.classList.add('jinsa-dropdown-enhanced');

    // Find the container grid div inside the dropdown
    const grid = dropdownInner.querySelector('.container--grid');
    if (grid) {
      // Replace the col-items (link list) with our custom HTML
      const colItems = grid.querySelector('.col-items');
      if (colItems) {
        colItems.innerHTML = html;
        return;
      }
      grid.insertAdjacentHTML('beforeend', `<div class="col-items">${html}</div>`);
      return;
    }

    // Fallback: append directly
    dropdownInner.insertAdjacentHTML('beforeend', html);
  }

  // ── Main: walk all top-level nav <li> items ───────────────────────────────
  function enhanceMenus() {
    const navItems = document.querySelectorAll(
      'header-menu .list-menu--inline > li[data-items-menu]'
    );

    navItems.forEach(li => {
      const titleEl = li.querySelector('summary a, a.menu-item-top');
      if (!titleEl) return;
      const titleText = titleEl.textContent.trim();

      const dropdownInner = li.querySelector('.dropdown-inner');
      if (!dropdownInner) return;

      if (matches(titleText, PRODUCTS_KEYWORDS)) {
        enhance(dropdownInner, buildCategoriesHTML());
      } else if (matches(titleText, BRANDS_KEYWORDS)) {
        enhance(dropdownInner, buildBrandsHTML());
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceMenus);
  } else {
    enhanceMenus();
  }
})();